import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Icon } from 'react-icons-kit';
import { download } from 'react-icons-kit/fa/download';
import { ic_remove_red_eye } from 'react-icons-kit/md/ic_remove_red_eye';

import Button from 'components/Button/Button';

import './Download.css';

declare var CONFIGURATIONS;

class Download extends Component {

  goToUrl = (url) => {
    window.open(url);
  }

  render() {
    const { t, data } = this.props;
    const downloadItems = [];
    data.forEach((f, index) => {
      const buttons = [];
      f.resources.forEach((r, index2) => {
        if (r.format === 'PNG') {
          buttons.push(
            <Button key={`downloadBtn${index}${index2}`} text={'Vista previa'} active={true} onClick={this.goToUrl.bind(null, r.url)}>
              <span>&nbsp;&nbsp;&nbsp;<Icon size={'18px'} icon={ic_remove_red_eye} /></span>
            </Button>
          );
        } else if (r.format === 'ZIP') {
          buttons.push(
            <Button key={`downloadBtn${index}${index2}`} text={'Descargar'} active={true} onClick={this.goToUrl.bind(null, r.url)}>
              <span>&nbsp;&nbsp;&nbsp;<Icon size={'18px'} icon={download} /></span>
            </Button>
          );
        }
      });

      const isNotDownloable = buttons.length === 1 && f.resources[0].format === 'PNG';
      downloadItems.push(
        <div key={`downloadItem${index}`}>
          <p className='downloadItemTitle' style={isNotDownloable ? { color: 'gray' } : {}}>{f.title}</p>
          <div style={{ display: 'flex', justifyContent: 'left', marginTop: '1.2rem', maxWidth: '405px' }}>
            { buttons }
            { isNotDownloable ?
              <Button text={'Fotograma no descargable'} active={false} onClick={undefined}>
                <span>&nbsp;&nbsp;&nbsp;<Icon size={'18px'} icon={download} /></span>
              </Button>
            : null }
          </div>
        </div>
      );
    });

    return (
      <React.Fragment>
        <div className='downloadListLinks'>
          <p dangerouslySetInnerHTML={{ __html: t('download.one_by_one') }} />
          <div className='listContainer'>
            {downloadItems}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default translate()(Download);
